import { Helmet } from 'react-helmet-async';
import { Stack, Container, Typography, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

import { authContext } from '../routes';
import { AppearanceSettings, SocialMedia } from '../sections/setting'; // LoginAttempt, UserSession

export default function SettingPage() {
  const { user } = useContext(authContext);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      const expirationDate = new Date(decodedToken.exp * 1000);
      if (expirationDate < new Date()) {
        localStorage.clear();
        navigate('/login');
      } else if (user && !user.role.permissions.dioceseLevel.update) {
        navigate('/dashboard');
      }
    } else {
      navigate('/login');
    }
  }, [navigate, user]);

  return (
    <>
      <Helmet>
        <title> ቅንብሮች | የሰ/ሸ/ሃ/መ/አ/ስርዓት </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" color="text.secondary">
            ቅንብሮች
          </Typography>
        </Stack>

        <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
            <SocialMedia />
          </Grid>
          {/* <Grid item xs={12} sm={12}>
            <LoginAttempt />
          </Grid>       
             <Grid item xs={12} sm={12}>
            <UserSession />
          </Grid> */}
          <Grid item xs={12} sm={12}>
            <AppearanceSettings />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
